// extracted by mini-css-extract-plugin
export default {"projectDetailsBody":"ProjectDetailsBody_projectDetailsBody__UzBSf"};